/**
 * Ringpuffer der letzten unabgefangenen Fehler (max. 15). Wird vom
 * globalErrorHandler befüllt und vom Melde-Werkzeug (bug-report) als
 * `consoleErrors` in den Diagnose-Payload übernommen.
 */
export interface CapturedError {
  message: string;
  stack?: string;
  source?: string;
  ts: string;
}

const MAX = 15;
const buffer: CapturedError[] = [];

export function recordError(entry: CapturedError): void {
  buffer.push(entry);
  if (buffer.length > MAX) buffer.shift();
}

export function getRecentErrors(n = 15): CapturedError[] {
  return buffer.slice(-n);
}

/** Test-Helfer: leert den Puffer zwischen Testfällen. */
export function clearErrorBuffer(): void {
  buffer.length = 0;
}
